import { MbscCalendarEvent } from '@mobiscroll/react';

import { AssignmentEvent } from './eventRenderers/AssignmentEvent';
import BreakCalendarEvent from './eventRenderers/BreakCalendarEvent/BreakCalendarEvent';
import { EventWaitTime } from './eventRenderers/EventWaitTime';
import { TripCalendarEvent } from './eventRenderers/TripCalendarEvent';

export function DispatchCalendarEvent({
  event,
}: {
  event?: MbscCalendarEvent;
}) {
  return (
    // Extra div is needed to avoid clipping of event badges or other positioned elements that we want to overflow
    // I narrowed it down to https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_display/Block_formatting_context
    // as a reason for this. Depending on this nuance allows us to keep badge logic in the trip calendar event component
    <div
      className={`relative h-full ${event?.trip ? 'min-h-[2rem]' : ''}`}
      data-testid={`dispatch-calendar-event-${event?.id}`}
      id={`event-${event?.id}`}
    >
      <div className="h-full overflow-hidden" data-testid="overflow-hider">
        {/* 
              TODO: Move the rest of the renderers to ./eventRenders/ and lift non TripCalendarEvent stuff out
              of that module.

              Also, need to think about typing here. Right now we're just duck typing the event.original
            */}
        {event?.assignmentEvent && (
          <AssignmentEvent
            variant={event.assignmentEvent.type}
            time={typeof event.start === 'string' ? event.start : ''}
          />
        )}
        {event?.trip && (
          <TripCalendarEvent trip={event.trip} type={event.type} />
        )}
        {event?.assignmentBreak && (
          <BreakCalendarEvent assignmentBreak={event.assignmentBreak} />
        )}
        {event?.waitTime && <EventWaitTime />}
      </div>
    </div>
  );
}
